module.exports = __webpack_public_path__ + "static/media/logo.f2d284d6.svg";